import CreateLookalikeAudienceModal from './CreateLookalikeAudienceModal.Container';

export default CreateLookalikeAudienceModal;
